export const SERVER_DATE = 'YYYY-MM-DD'
export const ABBREVIATED_MONTH_WITH_YEAR = 'MMM YYYY'

// Matches phone extensions like "x123", "ext123", "ext.123", "#123" with 1-8 digits
// Allows optional whitespace between prefix and digits, and trailing whitespace
export const PHONE_EXTENSION_REGEX = /(?:x|ext\.?|#)\s*(\d{1,8})\s*$/i
